import { Truck, Ban } from "lucide-react";

// Badge que indica si una tarifa trae recolección disponible (según
// rate.pickup estampado por la cotización). "Recolección" (verde) cuando el
// carrier/agregador soporta pickup; "Sin recolección" (gris) cuando no.
export default function PickupBadge({ pickup, size = "sm" }) {
  if (!pickup) return null;
  const sz = size === "xs" ? "text-[0.55rem] px-1 py-0.5" : "text-[0.6rem] px-1.5 py-0.5";
  if (pickup.available) {
    return (
      <span className={`flex items-center gap-1 ${sz} uppercase font-bold border border-success/40 text-success bg-success/10`} title={pickup.note || "Recolección disponible"}>
        <Truck className="w-3 h-3" /> Recolección
      </span>
    );
  }
  return (
    <span className={`flex items-center gap-1 ${sz} uppercase font-bold border border-ink-border text-ink-muted bg-ink/5`} title={pickup.note || "Sin recolección"}>
      <Ban className="w-3 h-3" /> Sin recolección
    </span>
  );
}